<template>
  <fullscreen :fullscreen.sync="fullscreen" class="fullscreen">
    <div class="video-container">
      <!-- 隐藏的audio元素 -->
      <audio ref="audio" src="@/assets/btnClcik.wav"></audio>
      <div v-show="loading" class="overlay">
        <i class="el-icon-loading" />加载中...
      </div>
      <video
        ref="video"
        oncontextmenu="return false"
        class="video"
        :muted="muted"
        webkit-playsinline="true"
        playsinline="true"
        x5-playsinline="true"
        x5-video-player-type="h5"
        x-webkit-airplay="allow"
        x5-video-player-fullscreen
        x5-video-orientation="landscape|portrait"
        @timeupdate="ontimeupdate"
        @playing="handlePlaying"
        @waiting="handleWaiting"
        @loadeddata="loadeddata"
        @canplay="playNextv"
        @ended="onended"
        @mousemove="showControlBar"
        @loadstart="paused = true"
        @play="getPlayData"
        @pause="showPlayOrPause"
        @loadedmetadata="autoPlay"
      >
        <source :src="vurl" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <!-- <div
        ref="control-bar"
        class="control-bar"
        :class="{ show: controlBarShow }"
      >
        <div class="control-bar-wrapper">
          <progress-bar
            ref="progressBar"
            v-model="currentTime"
            :disabled="fastForward"
            :duration="duration"
            :buffered="bufferedLength"
            @change="progressChange"
          />
        </div>
      </div> -->
      <div
        v-show="showOverContent"
        id="jw"
        class="fade-in"
        ref="jw"
        :key="timekey1"
      >
        <div class="showtext"></div>
        <el-button
          id="startBtn"
          class="changeBtnStyle1 btnbackground5"
          @click="playToStart()"
        ></el-button>
      </div>
      <div v-show="showSB" id="sb" class="fade-in" ref="sb" :key="timekey2">
        <el-button
          id="sbBtn"
          class="changeBtnStyle1 btnbackground5"
          @click="startGame()"
        ></el-button>
      </div>
      <div
        v-show="showChangeBeverage"
        id="scb"
        class="fade-in"
        ref="scb"
        :key="timekey3"
      >
        <div id="scbBtn" @click="clickBeverage()"></div>
        <div id="scbText" class="btnbackground6"></div>
        <div id="scbArrow" class="btnbackground9"></div>
      </div>
      <div
        v-show="showChangeBuyCar"
        id="scbc"
        class="fade-in"
        ref="scbc"
        :key="timekey4"
      >
        <el-button
          id="bcBtn"
          class="changeBtnStyle1 btnbackground7"
          @click="clickBuyCar(true)"
        ></el-button>
        <el-button
          id="nbcBtn"
          class="changeBtnStyle1 btnbackground8"
          @click="clickBuyCar(false)"
        ></el-button>
      </div>
      <div
        v-show="showWeaponWheel"
        id="sww"
        class="fade-in"
        ref="sww"
        :key="timekey6"
      >
        <canvas id="swwcanvas" ref="swwcanvas"></canvas>
        <canvas id="swwcanvasclick" ref="swwcanvasclick"></canvas>
      </div>
      <div v-show="showBB" id="sbb" class="fade-in" ref="sbb" :key="timekey7">
        <el-button
          id="sbbBtn"
          class="changeBtnStyle1 btnbackground10"
          @click="backChangeWeapon()"
        ></el-button>
      </div>
      <div
        id="playBtnTitle"
        v-show="paused && gameStart == false && gameRestart == false"
        style="
          width: 100%;
          line-height: 200%;
          border: none;
          background-color: transparent;
        "
      >
        <h1>真人互動游戲</h1>
        <h1>殺妻綫索</h1>
        <h1>先導體驗片</h1>
        <h1>Real person interactive games</h1>
        <h1>Wife killing clues</h1>
        <h1>Leading Experience Film</h1>
      </div>
      <el-button
        @click="handleVideoPause"
        v-show="paused && gameStart == false && gameRestart == false"
        circle
        id="playBtn"
        style="
          line-height: 200%;
          border: none;
          background-color: transparent;
          z-index: 99999;
        "
      >
        <h2>點擊開始</h2>
        <h2>Click to start</h2>
      </el-button>
      <div
        id="rsBtnTitle"
        v-show="gameRestart"
        style="
          width: 100%;
          line-height: 200%;
          border: none;
          background-color: transparent;
          z-index: 99999;
        "
      >
        <h1>真人互動游戲</h1>
        <h1>殺妻綫索</h1>
        <h1>敬請期待</h1>
        <h1>Real person interactive games</h1>
        <h1>Wife killing clues</h1>
        <h1>Stay tuned</h1>
      </div>
      <el-button
        @click="handleGameRestart"
        v-show="gameRestart"
        circle
        id="rsBtn"
        style="
          line-height: 200%;
          border: none;
          background-color: transparent;
          z-index: 99999;
        "
      >
        <h1>點擊重新開始</h1>
        <h1>Click to restart</h1>
      </el-button>
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="50%"
        :append-to-body="true"
        :close-on-click-modal="false"
      >
        <span
          >买车需要5000，您手里的资金只有2000，请点击分享按钮复制连接分享！</span
        >
        <span slot="footer" class="dialog-footer">
          <el-button style="color: #000" @click="clickNoShare">取 消</el-button>
          <el-button
            type="primary"
            v-clipboard:copy="herfUrl"
            v-clipboard:success="clipboardSuccess"
            @click="clickShare"
            >分 享</el-button
          >
        </span>
      </el-dialog>
    </div>
  </fullscreen>
</template>

<script>
import ProgressBar from "@/components/progress-bar/index";
import clip from "@/utils/clipboard"; // use clipboard directly
import clipboard from "@/directive/clipboard/index.js"; // use clipboard by v-directive
import request from "@/utils/request";

export default {
  name: "HomeView",
  components: { ProgressBar },
  directives: {
    clipboard,
  },
  filters: {
    filterDuration(val, that) {
      return that.formatTime(val);
    },
  },
  data() {
    return {
      fastForward: false,
      overlay: true,
      percentage: 0,
      nowPlayVideoFileName: "v0-1",
      video: null,
      audio: null,
      playnext: false,
      vurl: "",
      basevUrl: `https://movie.luckypay.cc/start/`,
      videoNextTreeList: {
        "v0-1": ["v1-1"],
        "v1-1": ["v1-2"],
        "v1-2": ["v1-3"],
        "v1-3": ["v1-4"],
        "v1-4": ["v2-1"],
        "v2-1": ["v2-2"],
        "v2-2": ["v2-2-1", "v2-2-2"],
        "v2-2-1": ["v2-2-1-0"],
        "v2-2-2": ["v2-2"],
        "v2-2-1-0": ["v2-2-1-0-1", "v2-2-1-0-2"],
      },
      showChangeList: [],
      loading: false, // 缓冲遮罩
      currentTime: 0, // 视频当前播放位置
      currentPercentage: 0, // 视频进度
      controlBarShow: false, // 是否显示控制栏
      duration: 0, // 视频总时长
      fullscreen: false, // 是否全屏
      muted: false,
      paused: true, // 是否为暂停状态
      showVolume: false,
      timeout: 0, // 延时器
      volume: 100,
      bufferedLength: 0,
      isNext: false,
      showOverContent: false,
      showSB: false,
      showChangeBeverage: false,
      showChangeBuyCar: false,
      showBB: false,
      herfUrl: "",
      gameStart: false,
      dialogVisible: false,
      isclickBuyCar: false,
      isclickNoBuyCar: false,
      showWeaponWheel: false,
      imgMultiple: 0,
      colorsHash: {},
      circles: [],
      isFirstPlay: 0,
      timekey1: new Date().getTime(),
      timekey2: new Date().getTime() - 10,
      timekey3: new Date().getTime() - 20,
      timekey4: new Date().getTime() - 30,
      timekey5: new Date().getTime() - 40,
      timekey6: new Date().getTime() - 50,
      timekey7: new Date().getTime() - 60,
      isPlayChangeFirst: false,
      isPlayChangeWeaponWheelFirst: false,
      gameRestart: false,
      isLandscape: false, //是否横屏
    };
  },
  mounted() {
    this.video = this.$refs.video;
    this.audio = this.$refs.audio;
    this.vurl = this.basevUrl + `${this.nowPlayVideoFileName}.mp4`;

    this.herfUrl = window.location.href;

    this.handleOrientationChange();
    // this.drawWeaponWheel();
  },
  created() {
    window.addEventListener("resize", this.handleOrientationChange);
  },
  destroyed() {
    window.addEventListener("resize", this.handleOrientationChange);
  },
  methods: {
    handleOrientationChange() {
      const html = document.getElementsByTagName("html")[0];
      console.log(html.clientWidth, html.clientHeight);
      const width = html.clientWidth;
      const height = html.clientHeight;
      width > height ? (this.isLandscape = true) : (this.isLandscape = false);
      console.log("获取是否横屏", this.isLandscape);
    },
    getPlayData() {
      // this.paused = false;
      // this.playnext = false;
      this.nowPlayVideoFileName = this.video.currentSrc.split("/").pop();
      this.nowPlayVideoFileName = this.nowPlayVideoFileName.split(".")[0];
      console.log("当前播放视频文件名", this.nowPlayVideoFileName);
    },
    showPlayOrPause() {
      this.paused = true;
    },
    playNextv() {
      if (!this.isNext) return;
      this.isNext = false;
      this.video.play();
    },
    handleGameRestart() {
      this.audio.currentTime = 0.3; // 重置音频到开始位置
      this.audio.play(); // 播放音频
      this.playnext = false;
      this.gameStart = true;
      this.gameRestart = false;
      this.vurl = this.basevUrl + "v0-1.mp4";
      this.video.load();
    },
    playToStart() {
      this.audio.currentTime = 0.3; // 重置音频到开始位置
      this.audio.play(); // 播放音频
      this.vurl = this.basevUrl + "v1-1.mp4";
      this.video.load();
      if (this.showOverContent) {
        this.$nextTick(() => {
          this.showOverContent = false;
          this.timekey1 = new Date().getTime();
          this.isFirstPlay = 0;
          this.$refs.jw.classList.remove("show");
        });
      }
      // this.video.loop = true;
      // this.isNext = true;
      // this.video.play();
      // this.playnext = false;
    },
    startGame() {
      this.audio.currentTime = 0.3; // 重置音频到开始位置
      this.audio.play(); // 播放音频
      this.vurl = this.basevUrl + "v1-2.mp4";
      this.video.load();
      this.video.loop = false;
      if (this.showSB) {
        this.$nextTick(() => {
          this.showSB = false;
          this.timekey2 = new Date().getTime();
          this.isFirstPlay = 0;
          this.$refs.sb.classList.remove("show");
        });
      }
      // this.isNext = true;
      // this.video.play();
      // this.playnext = false;
    },
    clickBeverage() {
      this.audio.currentTime = 0.3; // 重置音频到开始位置
      this.audio.play(); // 播放音频
      this.vurl = this.basevUrl + "v1-4.mp4";
      this.video.load();
      this.video.loop = false;
      if (this.showChangeBeverage) {
        this.$nextTick(() => {
          this.showChangeBeverage = false;
          this.timekey3 = new Date().getTime();
          this.isFirstPlay = 0;
          this.$refs.scb.classList.remove("show");
        });
      }
      // this.isNext = true;
      // this.video.play();
      // this.playnext = false;
    },
    autoPlay() {
      if (!this.gameStart) return;
      this.video.play();
    },
    playStartGameLoop() {
      this.vurl = this.basevUrl + "v1-1-0.mp4";
      this.video.load();
      this.video.loop = true;
      // this.isNext = true;
      // let playPromise = this.video.play();
      // if (playPromise !== undefined) {
      //   playPromise
      //     .then(() => {
      //       this.video.play();
      //     })
      //     .catch(() => {});
      // }
      // this.playnext = false;
    },
    playToBeverageChange() {
      this.vurl = this.basevUrl + "v1-3.mp4";
      this.video.load();
      this.video.loop = false;
      this.isPlayChangeFirst = false;
      // this.isNext = true;
      // this.video.play();
      // this.playnext = false;
    },
    playToBeverageChangeLoop() {
      this.vurl = this.basevUrl + "v1-3-0.mp4";
      this.video.load();
      this.video.loop = true;
      // this.isNext = true;
      // this.video.play();
      // this.playnext = false;
    },
    playToSecond() {
      this.vurl = this.basevUrl + "v2-1.mp4";
      this.video.load();
      this.video.loop = false;
      // this.isNext = true;
      // this.video.play();
      // this.playnext = false;
    },
    playToBuyCarLoop() {
      this.isclickBuyCar = false;
      this.isclickNoBuyCar = false;
      this.vurl = this.basevUrl + "v2-2.mp4";
      this.video.load();
      this.video.loop = true;

      // this.isNext = true;
      // this.video.play();
      // this.playnext = false;
    },
    clickBuyCar(isclick) {
      this.audio.currentTime = 0.3; // 重置音频到开始位置
      this.audio.play(); // 播放音频
      if (isclick) {
        this.playToBuyCar();
      } else {
        this.playToNoBuyCar();
      }
    },
    playToBuyCar() {
      this.dialogVisible = true;
      this.isclickBuyCar = true;
      this.audio.currentTime = 0.3; // 重置音频到开始位置
      this.audio.play(); // 播放音频
      if (this.showChangeBuyCar) {
        this.$nextTick(() => {
          this.showChangeBuyCar = false;
          this.timekey4 = new Date().getTime();
          this.isFirstPlay = 0;
          this.$refs.scbc.classList.remove("show");
        });
      }
    },
    playToNoBuyCar() {
      this.audio.currentTime = 0.3; // 重置音频到开始位置
      this.audio.play(); // 播放音频
      if (this.showChangeBuyCar) {
        this.$nextTick(() => {
          this.isclickNoBuyCar = true;
          this.showChangeBuyCar = false;
          this.timekey4 = new Date().getTime();
          this.isFirstPlay = 0;
          this.$refs.scbc.classList.remove("show");
        });
      }
      this.vurl = this.basevUrl + "v2-2-2.mp4";
      this.video.load();
      this.video.loop = false;
    },
    backChangeWeapon() {
      this.audio.currentTime = 0.3; // 重置音频到开始位置
      this.audio.play(); // 播放音频
      if (this.showBB) {
        this.$nextTick(() => {
          this.showBB = false;
          this.isPlayChangeWeaponWheelFirst = false;
          this.timekey10 = new Date().getTime();
          this.isFirstPlay = 0;
          this.$refs.sbb.classList.remove("show");
        });
      }
      this.vurl = this.basevUrl + "v2-2-1-0.mp4";
      this.video.load();
      this.video.loop = true;
    },
    playToChangeW(change) {
      this.audio.currentTime = 0.3; // 重置音频到开始位置
      this.audio.play(); // 播放音频
      if (this.isLandscape) {
        if (change == 4) {
          this.vurl = this.basevUrl + "v2-2-1-0-1.mp4";
          this.video.load();
          this.video.loop = false;
        } else if (change == 5) {
          this.vurl = this.basevUrl + "v2-2-1-0-2.mp4";
          this.video.load();
          this.video.loop = false;
        }
      } else {
        if (change == 1) {
          this.vurl = this.basevUrl + "v2-2-1-0-1.mp4";
          this.video.load();
          this.video.loop = false;
        } else if (change == 0) {
          this.vurl = this.basevUrl + "v2-2-1-0-2.mp4";
          this.video.load();
          this.video.loop = false;
        }
      }

      if (this.showWeaponWheel) {
        this.$nextTick(() => {
          this.showWeaponWheel = false;
          this.timekey6 = new Date().getTime();
          this.isFirstPlay = 0;
          this.$refs.sww.classList.remove("show");
        });
      }
    },
    clickShare() {
      this.dialogVisible = false;
      if (this.showChangeBuyCar) {
        this.showChangeBuyCar = false;
        this.timekey4 = new Date().getTime();
        this.$refs.scbc.classList.remove("show");
      }
      let data = {};
      request({
        url: "/pick",
        method: "post",
        data,
      })
        .then((res) => {})
        .catch((error) => {
          // reject(error);
        });
      this.audio.currentTime = 0.3; // 重置音频到开始位置
      this.audio.play(); // 播放音频
      this.vurl = this.basevUrl + "v2-2-1.mp4";
      this.video.load();
      this.video.loop = false;
    },
    clickNoShare() {
      this.isclickBuyCar = false;
      this.dialogVisible = false;
      this.showChangeBuyCar = true;
      this.timekey4 = new Date().getTime();
      this.audio.currentTime = 0.3; // 重置音频到开始位置
      this.audio.play(); // 播放音频
      this.$nextTick(() => {
        this.$refs.scbc.classList.add("show");
      });
    },
    playbc() {
      this.vurl = this.basevUrl + "v2-2-1-0.mp4";
      this.video.load();
      this.video.loop = true;
      this.isPlayChangeWeaponWheelFirst = false;
    },
    drawWeaponWheel() {
      let sww = this.$refs.sww;
      let lp = null;
      let swwcanvas = this.$refs.swwcanvas;
      swwcanvas.width = sww.clientWidth;
      swwcanvas.height = sww.clientHeight;

      const ctx = swwcanvas.getContext("2d");
      const hitCanvas = this.$refs.swwcanvasclick;
      const hitCtx = hitCanvas.getContext("2d");
      hitCanvas.width = sww.clientWidth;
      hitCanvas.height = sww.clientHeight;
      ctx.clearRect(0, 0, swwcanvas.width, swwcanvas.height); //清空所有的内容
      ctx.save();
      ctx.translate(sww.clientWidth / 2, sww.clientHeight / 2);
      hitCtx.clearRect(0, 0, swwcanvas.width, swwcanvas.height); //清空所有的内容
      hitCtx.save();
      hitCtx.translate(sww.clientWidth / 2, sww.clientHeight / 2);
      let sources = {
        lunpan: require("@/assets/img/lunpan.png"),
        bqg: require("@/assets/img/bangqiugun.png"),
        bqgt: require("@/assets/img/bangqiuguntext.png"),
        qt: require("@/assets/img/quantou.png"),
        qtt: require("@/assets/img/quantoutext.png"),
        select: require("@/assets/img/select.png"),
        empty: require("@/assets/img/Empty.png"),
      };
      this.loadImages(sources, (images) => {
        lp = this.calculateImg(
          sww.clientWidth,
          sww.clientHeight,
          images.lunpan
        );
        ctx.drawImage(
          images.lunpan,
          -(lp.imgWigth / 2),
          -(lp.imgHeight / 2),
          lp.imgWigth,
          lp.imgHeight
        );
        ctx.drawImage(
          images.bqg,
          lp.imgWigth / 2 -
            images.bqg.width * this.imgMultiple * 0.8 -
            lp.imgWigth / 12,
          -(
            lp.imgHeight / 4 +
            (images.bqg.height * this.imgMultiple * 0.8) / 2
          ),
          images.bqg.width * this.imgMultiple * 0.8,
          images.bqg.height * this.imgMultiple * 0.8
        );
        ctx.drawImage(
          images.bqgt,
          lp.imgWigth / 2 - images.bqg.width * this.imgMultiple * 0.8 * 1.2,
          -(
            lp.imgHeight / 4 +
            images.bqgt.height * this.imgMultiple * 0.8 -
            images.bqg.height * this.imgMultiple * 0.8
          ),
          images.bqgt.width * this.imgMultiple * 0.8,
          images.bqgt.height * this.imgMultiple * 0.8
        );
        ctx.drawImage(
          images.qt,
          -images.qtt.width * this.imgMultiple * 0.8 -
            (images.qt.width * this.imgMultiple * 0.8) / 4,
          -(
            lp.imgHeight * 0.56 -
            (images.qt.height * this.imgMultiple * 0.8) / 2
          ),
          images.qt.width * this.imgMultiple * 0.8,
          images.qt.height * this.imgMultiple * 0.8
        );
        ctx.drawImage(
          images.qtt,
          0,
          -(lp.imgHeight * 0.42),
          images.qtt.width * this.imgMultiple * 0.8,
          images.qtt.height * this.imgMultiple * 0.8
        );
        ctx.drawImage(
          images.empty,
          -(
            lp.imgWigth / 2 -
            (images.empty.width * this.imgMultiple * 0.8) / 2
          ),
          -(
            lp.imgHeight / 4 -
            (images.empty.height * this.imgMultiple * 0.8) / 2
          ),
          images.empty.width * this.imgMultiple * 0.8,
          images.empty.height * this.imgMultiple * 0.8
        );
        ctx.drawImage(
          images.empty,
          -(
            lp.imgWigth / 2 -
            (images.empty.width * this.imgMultiple * 0.8) / 2
          ),
          lp.imgHeight / 4 - images.empty.height * this.imgMultiple * 0.8,
          images.empty.width * this.imgMultiple * 0.8,
          images.empty.height * this.imgMultiple * 0.8
        );
        ctx.drawImage(
          images.empty,
          (-images.empty.width * this.imgMultiple * 0.8) / 2,
          lp.imgHeight * 0.45 - images.empty.height * this.imgMultiple * 0.8,
          images.empty.width * this.imgMultiple * 0.8,
          images.empty.height * this.imgMultiple * 0.8
        );
        ctx.drawImage(
          images.empty,
          lp.imgWigth / 2 - images.empty.width * this.imgMultiple * 0.8 * 1.5,
          lp.imgHeight / 4 - images.empty.height * this.imgMultiple * 0.8,
          images.empty.width * this.imgMultiple * 0.8,
          images.empty.height * this.imgMultiple * 0.8
        );
        ctx.save();
        this.circles = [];
        this.colorsHash = {};
        for (let i = 0; i < 6; i++) {
          this.circles.push({
            id: i,
            colorKey: null,
          });
        }

        this.circles.forEach((circle) => {
          while (true) {
            let colorKey = this.getRandomColor();
            if (!this.colorsHash[colorKey]) {
              circle.colorKey = colorKey;
              this.colorsHash[colorKey] = circle;
              return;
            }
          }
        });
        this.circles.forEach((circle, i) => {
          hitCtx.fillStyle = circle.colorKey;
          hitCtx.beginPath();
          hitCtx.moveTo(0, 0);
          hitCtx.arc(
            0,
            0,
            lp.imgWigth / 2,
            i * 60 * (Math.PI / 180),
            (i + 1) * 60 * (Math.PI / 180)
          );
          hitCtx.closePath();
          hitCtx.fill();
        });
        hitCanvas.addEventListener(
          "click",
          (e) => {
            const mousePos = {
              x: e.clientX - hitCanvas.offsetLeft,
              y: e.clientY - hitCanvas.offsetTop,
            };
            let pixel = null;
            if (this.isLandscape) {
              pixel = hitCtx.getImageData(mousePos.x, mousePos.y, 1, 1).data;
            } else {
              pixel = hitCtx.getImageData(mousePos.y, mousePos.x, 1, 1).data;
            }
            const color = `rgb(${pixel[0]},${pixel[1]},${pixel[2]})`;
            const shape = this.colorsHash[color];
            this.audio.currentTime = 0.3; // 重置音频到开始位置
            this.audio.play(); // 播放音频
            console.log(mousePos, "-----", color, shape, this.colorsHash);
            if (shape) {
              console.log("序号", shape.id);
              // alert("click on: " + shape.id);
              this.playToChangeW(shape.id);
            }
          },
          false
        );
      });
    },
    selectWW() {},
    getRandomColor() {
      const r = Math.round(Math.random() * 255);
      const g = Math.round(Math.random() * 255);
      const b = Math.round(Math.random() * 255);
      return `rgb(${r},${g},${b})`;
    },
    /**
     * 画布添加事件
     */
    canvasAddEvent() {
      let cc = this.$refs.swwcanvasclick;
      cc.onclick = (e) => {
        console.log("点击事件", e);
      };
    },
    /**重绘大致点击图形 */

    canvasclickdraw() {
      let sww = this.$refs.sww;
      let cc = this.$refs.swwcanvasclick;
      cc.width = sww.clientWidth;
      cc.height = sww.clientHeight;
      // this.canvasAddEvent();
      const cctx = cc.getContext("2d");
      //重绘
      // 清除画布
      cctx.clearRect(-250, -250, 500, 500);
      // 处理角度
      if (angle >= 360) {
        angle = 0;
      }
      // 处理速度
      seep *= 0.95; // 减小速度
      angle += seep;
      // 画短线
      cctx.beginPath();
      cctx.strokeStyle = "red";
      cctx.lineWidth = 2;
      cctx.moveTo(150, 0);
      cctx.lineTo(180, 0);
      cctx.stroke();
      // 保存环境,旋转画布
      cctx.strokeStyle = "chartreuse";
      cctx.save();
      cctx.rotate(angle * oH);
      // 画扇形
      for (var i = 0; i < 8; i++) {
        cctx.fillStyle = colorArr[i];
        cctx.beginPath();
        cctx.moveTo(0, 0);
        cctx.arc(0, 0, 150, i * 45 * oH, (i + 1) * 45 * oH);
        cctx.closePath();
        cctx.fill();
        cctx.stroke();
      }
      // 画中心圆
      cctx.fillStyle = "#FFF";
      cctx.beginPath();
      cctx.arc(oX, oY, oR1, 0, 2 * Math.PI);
      cctx.fill();
      // 添加文字
      for (var i = 0; i < textArr.length; i++) {
        cctx.save();
        cctx.rotate((i * 45 + 25) * oH);
        cctx.fillStyle = "#fff";
        cctx.font = "16px 微软雅黑";
        cctx.fillText(textArr[i], 70, 0);
        cctx.restore();
      }
      cctx.restore();
      // 环境释放与环境保存成对
    },
    /**
     *图片计算缩放
     */
    calculateImg(canvasW, canvasH, image) {
      let imgMultiple = 0;
      if (image.width > canvasW || image.height > canvasH) {
        if (canvasW / image.width > canvasH / image.height) {
          if (canvasW / image.width < 1 && canvasH / image.height < 1) {
            imgMultiple = canvasW / image.width;
          } else if (canvasW / image.width > 1 && canvasH / image.height < 1) {
            imgMultiple = canvasH / image.height;
          }
        } else if (canvasW / image.width < canvasH / image.height) {
          if (canvasW / image.width < 1 && canvasH / image.height < 1) {
            imgMultiple = canvasH / image.height;
          } else if (canvasW / image.width < 1 && canvasH / image.height > 1) {
            imgMultiple = canvasW / image.width;
          }
        } else {
          imgMultiple = canvasW / image.width;
        }
      } else if (image.width < canvasW && image.height < canvasH) {
        if (canvasW / image.width > canvasH / image.height) {
          imgMultiple = canvasH / image.height;
        } else if (canvasW / image.width < canvasH / image.height) {
          imgMultiple = canvasW / image.width;
        } else {
          console.log(
            1111,
            canvasW / image.width,
            canvasH / image.height,
            image.width,
            image.height
          );
          imgMultiple = 1;
        }
      } else {
        imgMultiple = 1;
      }
      let imgWigth = imgMultiple * image.width * 0.8;
      let imgHeight = imgMultiple * image.height * 0.8;
      this.imgMultiple = imgMultiple;
      return {
        imgWigth,
        imgHeight,
      };
    },
    /*
     *实现一系列图片的预加载
     *参数sources:图片信息关联数组
     *参数callback:回调函数——图片预加载完成后立即执行此函数。
     */
    loadImages(sources, callback) {
      let count = 0,
        images = {},
        imgNum = 0;
      for (let src in sources) {
        imgNum++;
      }
      for (let src in sources) {
        images[src] = new Image();
        images[src].onload = () => {
          if (++count >= imgNum) {
            callback(images);
          }
        };
        images[src].src = sources[src];
      }
    },
    loadeddata() {
      this.duration = this.video.duration;
      this.currentTime = this.video.currentTime;
      this.volumeChange(this.volume);
    },
    ontimeupdate() {
      // ontimeupdate 触发间隔为 250ms
      const video = this.video;
      const currentTime = video.currentTime;
      // if (this.duration > 0) {
      for (let i = 0; i < video.buffered.length; i++) {
        // 寻找当前时间之后最近的点
        if (video.buffered.start(video.buffered.length - 1 - i) < currentTime) {
          this.bufferedLength =
            (video.buffered.end(video.buffered.length - 1 - i) /
              video.duration) *
              100 +
            "%";
          break;
        }
      }
      // }
      this.currentTime = currentTime;
      if (
        Math.floor(currentTime) == 61 &&
        this.nowPlayVideoFileName == "v0-1" &&
        this.showOverContent == false
      ) {
        this.showOverContent = true;
        this.timekey1 = new Date().getTime();
      }
      if (
        Math.floor(currentTime) == 62 &&
        this.nowPlayVideoFileName == "v0-1" &&
        this.isFirstPlay == 0
      ) {
        this.isFirstPlay++;
        this.$nextTick(() => {
          this.$refs.jw.classList.add("show");
        });
      }
      if (
        Math.floor(currentTime) == 21 &&
        this.nowPlayVideoFileName == "v1-1" &&
        this.showSB == false
      ) {
        this.showSB = true;
        this.timekey2 = new Date().getTime();
      }
      if (
        Math.floor(currentTime) == 22 &&
        this.nowPlayVideoFileName == "v1-1" &&
        this.isFirstPlay == 0
      ) {
        this.isFirstPlay++;
        this.$nextTick(() => {
          this.$refs.sb.classList.add("show");
        });
      }
      if (
        Math.floor(currentTime) == 0 &&
        this.nowPlayVideoFileName == "v1-3" &&
        this.showChangeBeverage == false &&
        this.isPlayChangeFirst == false
      ) {
        this.showChangeBeverage = true;
        this.isPlayChangeFirst = true;
        this.timekey3 = new Date().getTime();
      }
      if (
        Math.floor(currentTime) == 1 &&
        this.nowPlayVideoFileName == "v1-3" &&
        this.isFirstPlay == 0
      ) {
        this.isFirstPlay++;
        this.$nextTick(() => {
          this.$refs.scb.classList.add("show");
        });
      }
      if (
        Math.floor(currentTime) == 0 &&
        this.nowPlayVideoFileName == "v2-2" &&
        this.showChangeBuyCar == false &&
        this.isclickBuyCar == false &&
        this.isclickNoBuyCar == false
      ) {
        this.showChangeBuyCar = true;
        this.timekey4 = new Date().getTime();
      }
      if (
        Math.floor(currentTime) == 1 &&
        this.nowPlayVideoFileName == "v2-2" &&
        this.isclickBuyCar == false &&
        this.isclickNoBuyCar == false &&
        this.isFirstPlay == 0
      ) {
        this.isFirstPlay++;
        this.$nextTick(() => {
          this.$refs.scbc.classList.add("show");
        });
      }
      if (
        Math.floor(currentTime) == 0 &&
        this.nowPlayVideoFileName == "v2-2-1-0" &&
        this.showWeaponWheel == false &&
        this.isPlayChangeWeaponWheelFirst == false
      ) {
        this.showWeaponWheel = true;
        this.isPlayChangeWeaponWheelFirst = true;
        this.timekey6 = new Date().getTime();
      }
      if (
        Math.floor(currentTime) == 1 &&
        this.nowPlayVideoFileName == "v2-2-1-0" &&
        this.isFirstPlay == 0
      ) {
        this.isFirstPlay++;
        this.$nextTick(() => {
          this.$refs.sww.classList.add("show");
        });
        this.drawWeaponWheel();
      }
      if (
        Math.floor(currentTime) == 90 &&
        this.nowPlayVideoFileName == "v2-2-1-0-1" &&
        this.showBB == false
      ) {
        this.showBB = true;
        this.timekey10 = new Date().getTime();
      }
      if (
        Math.floor(currentTime) == 91 &&
        this.nowPlayVideoFileName == "v2-2-1-0-1" &&
        this.isFirstPlay == 0
      ) {
        this.isFirstPlay++;
        this.$nextTick(() => {
          this.$refs.sbb.classList.add("show");
        });
      }
      if (
        Math.floor(currentTime) == 71 &&
        this.nowPlayVideoFileName == "v2-2-1-0-2" &&
        this.showBB == false
      ) {
        this.showBB = true;
        this.timekey10 = new Date().getTime();
      }
      if (
        Math.floor(currentTime) == 72 &&
        this.nowPlayVideoFileName == "v2-2-1-0-2" &&
        this.isFirstPlay == 0
      ) {
        this.isFirstPlay++;
        this.$nextTick(() => {
          this.$refs.sbb.classList.add("show");
        });
      }
    },
    formatTime(t) {
      let time = "0:00";
      if (t) {
        const h = parseInt(t / 3600);
        const m = parseInt((t % 3600) / 60);
        let s = parseInt(t % 60);
        s = s < 10 ? "0" + s : s;
        time = h ? h + ":" + m + ":" + s : m + ":" + s;
      }
      return time;
    },
    handleMuted() {
      this.video.muted = !this.video.muted;
      this.muted = this.video.muted;
    },
    handleVideoPause() {
      this.audio.currentTime = 0.3; // 重置音频到开始位置
      this.audio.play(); // 播放音频
      try {
        if (this.paused) {
          this.video.play();
          this.paused = false;
        } else {
          this.video.pause();
          this.paused = true;
        }
        this.playnext = false;
        this.gameStart = true;
      } catch (error) {
        console.log(error);
        alert(error);
        this.playnext = false;
        this.gameStart = true;
      }
    },
    handleWaiting() {
      this.loading = true;
    },
    handlePlaying() {
      this.loading = false;
    },
    volumeChange(vol) {
      this.muted = this.video.muted = vol / 100 <= 0;
      // The volume provided must at the range [0, 1]
      this.video.volume = vol / 100;
    },
    handleFullscreen() {
      this.fullscreen = !this.fullscreen;
    },
    progressChange(val) {
      this.video.currentTime = val;
    },
    // 视频播放完成
    onended() {
      this.showChangeList = [];
      // if (this.videoNextTreeList.length == 0) {
      //   return;
      // }
      // this.videoNextTreeList[this.nowPlayVideoFileName].forEach((element) => {
      //   this.showChangeList.push(element);
      // });
      if (this.nowPlayVideoFileName == "v1-1") {
        this.playStartGameLoop();
      }
      if (this.nowPlayVideoFileName == "v1-2") {
        this.playToBeverageChange();
      }
      if (this.nowPlayVideoFileName == "v1-3") {
        this.playToBeverageChangeLoop();
      }
      if (this.nowPlayVideoFileName == "v1-4") {
        this.playToSecond();
      }
      if (
        this.nowPlayVideoFileName == "v2-1" ||
        this.nowPlayVideoFileName == "v2-2-2"
      ) {
        this.playToBuyCarLoop();
      }
      if (this.nowPlayVideoFileName == "v2-2-1") {
        this.playbc();
      }
      if (
        this.nowPlayVideoFileName == "v2-2-1-0-1" ||
        this.nowPlayVideoFileName == "v2-2-1-0-2"
      ) {
        this.isNext = false;
        this.showOverContent = false;
        this.showSB = false;
        this.showChangeBeverage = false;
        this.showChangeBuyCar = false;
        this.showBB = false;
        this.$refs.sbb.classList.remove("show");
        this.gameStart = false;
        this.dialogVisible = false;
        this.isclickBuyCar = false;
        this.isclickNoBuyCar = false;
        this.showWeaponWheel = false;
        this.imgMultiple = 0;
        this.colorsHash = {};
        this.circles = [];
        this.isFirstPlay = 0;
        this.isPlayChangeFirst = false;
        this.isPlayChangeWeaponWheelFirst = false;
        this.gameRestart = true;
      }
      // this.playnext = true;
      this.$emit("ended");
    },
    handleMenuChange(val, index) {
      this.$emit("change", val, index);
    },
    showControlBar(clear = true) {
      this.timeout && window.clearTimeout(this.timeout);
      this.timeout = 0;
      this.controlBarShow = true;
      if (clear) {
        this.timeout = window.setTimeout(this.hideControlBar, 3000);
      }
    },
    hideControlBar() {
      this.controlBarShow = false;
    },
    clipboardSuccess() {
      this.$message({
        message: "复制成功！",
        type: "success",
        duration: 1500,
        customClass: "copy-success",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.video-container {
  position: relative;
  width: 100%;
  height: 100%;
  /* padding-bottom: 56.25%; */
  overflow: hidden;
  color: #fff;
  /* 16:9 Aspect Ratio */
}

video {
  background-color: #000;
}
/* 全屏按钮 */
video::-webkit-media-controls-fullscreen-button {
  display: none;
}
video::--webkit-media-controls-play-button {
  display: none !important;
  --webkit-appearance: none !important;
}
.video-container video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  /* transform: translateZ(-100px); */
  /* height: 100vh; */
  object-fit: contain; /* 确保视频内容全部显示 */
}
.video-container #playBtn {
  position: fixed;
  bottom: -8%;
  left: 50%;
  transform: translate3d(-50%, -50%, 100px);
  z-index: 100;
}
.video-container #playBtnTitle {
  position: fixed;
  top: 36%;
  left: 50%;
  transform: translate3d(-50%, -50%, 100px);
  z-index: 100;
}
.video-container #rsBtnTitle {
  position: fixed;
  top: 36%;
  left: 50%;
  transform: translate3d(-50%, -50%, 100px);
  z-index: 100;
}
.video-container #rsBtn {
  position: fixed;
  bottom: -8%;
  left: 50%;
  transform: translate3d(-50%, -50%, 100px);
  z-index: 100;
}
.video-container #fullBtn {
  position: fixed;
  top: 3%;
  right: 0%;
  transform: translate3d(-50%, -50%, 100px);
  z-index: 100;
}
.video-container #jw .showtext {
  /* position: fixed;
  top: 40%;
  left: 50%;
  transform: translate3d(-50%, -50%, 100px); */
  z-index: 100;
  width: calc(23.3rem * 0.5);
  height: calc(6.6rem * 0.5);
  margin-bottom: 1rem;
  background-image: url("@/assets/img/showovertext.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
}
/* .video-container #startBtn {
  position: fixed;
  bottom: -10%;
  left: 50%;
  transform: translate3d(-50%, -50%, 100px);
  z-index: 100;
} */
.video-container #sbBtn {
  position: absolute;
  bottom: 8%;
  left: 28%;
  transform: translate3d(-50%, -50%, 100px);
  z-index: 100;
}
.video-container #sbbBtn {
  position: absolute;
  bottom: -2%;
  right: 2%;
  transform: translate3d(-50%, -50%, 100px);
  z-index: 100;
}
.video-container #scbBtn {
  position: absolute;
  bottom: -2%;
  left: 45%;
  transform: translate3d(-50%, -50%, 100px);
  z-index: 100;
  width: 10rem;
  height: 15rem;
  /* border: 1px solid; */
}
.video-container #scbText {
  position: absolute;
  bottom: 18%;
  left: 28%;
  transform: translate3d(-50%, -50%, 100px);
  z-index: 100;
}
.video-container #scbArrow {
  position: absolute;
  bottom: 35%;
  left: 35%;
  transform: translate3d(-50%, -50%, 100px);
  z-index: 100;
}
.video-container #nbcBtn {
  position: absolute;
  bottom: 0%;
  right: 15%;
  transform: translate3d(-50%, -50%, 100px);
  z-index: 100;
}
.video-container #bcBtn {
  position: absolute;
  bottom: 0%;
  left: 35%;
  transform: translate3d(-50%, -50%, 100px);
  z-index: 100;
}

.video-container #changeBtnGroup {
  position: absolute;
  bottom: 2%;
  left: 50%;
  transform: translate3d(-50%, -50%, 100px);
  z-index: 100;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
}
.video-container #jw {
  position: relative;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  transform: translateZ(100px);
}
.video-container #sb {
  position: relative;
  z-index: 100;
  width: 100%;
  height: 100%;
}
.video-container #scb {
  position: relative;
  z-index: 100;
  width: 100%;
  height: 100%;
}
.video-container #scbc {
  position: relative;
  z-index: 100;
  width: 100%;
  height: 100%;
}
.video-container #sww {
  position: relative;
  z-index: 100;
  /* display: flex; */
  /* flex-direction: row; */
  /* justify-content: center;
  align-items: center; */
  width: 100%;
  height: 100%;
}
.video-container #swwcanvas {
  position: absolute;
  left: 0;
  top: 0;
}
.video-container #swwcanvasclick {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.fade-in {
  /* 初始状态，设置元素透明度为0，使其不可见 */
  opacity: 0;
  /* 添加过渡效果，指定持续时间和效果类型 */
  transition: opacity 2s ease-in-out;
  visibility: hidden;
}

/* 当元素被添加额外的类（例如 .show）时，改变其透明度 */
.fade-in.show {
  opacity: 1 !important; /* 设置为1，元素变得完全可见 */
  visibility: visible;
}
.changeBtnStyle1 {
  font-size: 18px;
  color: rgb(246, 251, 255);
  text-shadow: 0px -3px 13px rgba(131, 255, 181, 0.32);
}
.changeBtnStyle2 {
  font-size: 18px;
  color: rgb(246, 251, 255);
  text-shadow: 0px 2px 0px rgba(41, 41, 41, 0.004);
}
.btnbackground1 {
  background-image: url("@/assets/group1.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  color: #fff;
  width: 154px;
  height: 67px;
}
.btnbackground2 {
  background-image: url("@/assets/group2.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  color: #fff;
  width: 129px;
  height: 49px;
}
.btnbackground3 {
  background-image: url("@/assets/group3.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  color: #fff;
  width: 137px;
  height: 46px;
}
.btnbackground4 {
  background-image: url("@/assets/group4.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  color: #fff;
  width: 121px;
  height: 100px;
}
.btnbackground5 {
  background-image: url("@/assets/img/inputgame.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  color: #fff;
  width: calc(20.4rem * 0.5);
  height: calc(6.9rem * 0.5);
}
.btnbackground6 {
  background-image: url("@/assets/img/clickyinliao.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  color: #fff;
  width: calc(23.3rem * 0.5);
  height: calc(5.5rem * 0.5);
}
.btnbackground7 {
  background-image: url("@/assets/img/buycarbtn.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  color: #fff;
  width: calc(20.8rem * 0.5);
  height: calc(7rem * 0.5);
}
.btnbackground8 {
  background-image: url("@/assets/img/nobuycarbtn.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  color: #fff;
  width: calc(20.8rem * 0.5);
  height: calc(7rem * 0.5);
}
.btnbackground9 {
  background-image: url("@/assets/img/arrow.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  color: #fff;
  width: calc(10.75rem * 0.5);
  height: calc(5.25rem * 0.5);
}
.btnbackground10 {
  background-image: url("@/assets/img/backBtn.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  color: #fff;
  width: calc(20.8rem * 0.5);
  height: calc(7rem * 0.5);
}
::v-deep#changeBtnGroup .el-button:focus,
.el-button:hover {
  background-color: transparent;
  border: none;
}
::v-deep#jw,
#sb,
#scb,
#scbc,
#sbb .el-button:focus,
.el-button:hover {
  background-color: transparent;
  border: none;
}
::v-deep.el-button {
  color: #fff;
}
::v-deep.el-button:focus,
.el-button:hover {
  color: #409eff;
}
.fullscreen {
  height: 100%;
}
.main-container {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: #000;
}
.main-container.is-fullscreen {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2000;
}
.control-bar:hover,
.control-bar.show {
  opacity: 1;
  visibility: visible;
}
.control-bar {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 10px;
  background: rgba(0, 0, 0, 0.7);
  opacity: 0;
  visibility: hidden;
  transition: all 300ms linear;
}
.overlay,
.video-box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video {
  width: 100%;
  height: 100%;
}
.centered-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.overlay {
  z-index: 199;
  background: #000000db;
  .el-button {
    width: 140px;
    height: 48px;
    background: #1479f9;
    color: #fff;
    font-size: 18px;
    border-color: #1479f9;
    border-radius: 24px;
    transition: cubic-bezier(0.075, 0.82, 0.165, 1);
    &:hover {
      background: #1974e8;
    }
  }
}

.control-bar-wrapper {
  position: relative;
  height: 100%;
}
.control-bar-inner {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
  transition: background linear;
}

.control-bar-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  /* padding: 0 16px; */
  span + span {
    margin-left: 10px;
  }
  .svg-icon + span {
    margin-left: 22px;
  }
  i:hover {
    color: #1974e8 !important;
    cursor: pointer;
  }
}
.control-bar-inner__left,
.control-bar-inner__right,
.control-item {
  height: 100%;
}

.control-item {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  user-select: none;
}

.svg-icon {
  cursor: pointer;
  font-size: 18px;
}
.masked-area {
  position: relative;
  width: 100%;
  height: 100%; /* 或者你需要的任何高度 */
}

.masked-area .content {
  position: relative;
  z-index: 1000000; /* 确保内容在遮罩层之上 */
}

.masked-area::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5); /* 半透明遮罩层 */
  z-index: 999999;
  pointer-events: none; /* 阻止点击事件 */
}
.menu-block {
  .menu-context {
    display: none;
    position: absolute;
    right: 0;
    bottom: 26px;
    padding-bottom: 26px;
  }
  &:hover .menu-context,
  .menu-context:hover {
    display: block;
  }
}

::v-deep.volume-block {
  border-radius: 20px;
  font-size: 18px;
  .volume {
    position: absolute;
    bottom: 26px;
    right: 50%;
    transform: translateX(50%);
    z-index: 9;
    padding-bottom: 26px;
    display: none;
  }
  .volume:hover,
  &:hover .volume {
    display: block;
  }
  .el-slider.is-vertical {
    padding: 12px 14px;
    background: #000000b3;
    border-radius: 4px;

    .el-slider__bar {
      background-color: #fff;
    }
    .el-slider__button {
      border-color: #000000b3;
    }
    & .el-slider__runway {
      background-color: #999;
    }
    & .el-slider__runway,
    & .el-slider__bar {
      width: 2px;
      margin: 0;
    }
    & .el-slider__button-wrapper {
      left: 50%;
      transform: translate(-50%, 50%);
    }
  }
}
::v-deep.el-dialog__wrapper {
  transform: translateZ(110px) !important;
}
::v-deep.el-message {
  transform: translate3d(-50%, 0, 110px) !important;
}
.copy-success {
  transform: translate3d(-50%, 0, 110px) !important;
}
</style>
